import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IdentityAuthProviderService } from '../../app/shared/common/auth/identity-auth-provider.service';

@Component({
  selector: 'app-check-auth',
  templateUrl: './check-auth.component.html',
  styleUrls: ['./check-auth.component.css']
})
export class CheckAuthComponent implements OnInit {

    constructor(private router: Router, private route: ActivatedRoute, private authService: IdentityAuthProviderService) { }

    ngOnInit(): void {
        abp.ui.setBusy();
        setTimeout(() => {
            this.authService.getUserStatus(() => {
                abp.ui.clearBusy();
            });
        }, 150);
  }

}
